export default __webpack_public_path__ + "static/tt-norms-bold-b88b9037f39dacc82c02e09568f61a69.woff";